import {RouteRecordRaw} from 'vue-router';
import {Role} from '../../../records/user.record';

export default function (rootName: string): RouteRecordRaw[] {
    return [
        {
            path: `dispatcher-settings`,
            name: `${rootName}DispatcherSettings`,
            component: () => import('../../settings/account-settings/DispatcherSettingsForm.vue'),
            props: (route) => {
                return Object.assign({
                    backRouteName: rootName
                });
            },
            meta: {
                roles: [Role.DISPATCHER, Role.ADMIN]
            }
        }
    ];
}
